<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Move files</div>

    <div class="modal-body cl-form">
      <p class="mb-3">You are about to move the following files</p>
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny">
                Type
              </th>
              <th class="cl-table-head cl-p-tiny">
                File or folder name
              </th>
              <th class="cl-table-head cl-p-tiny">
                <div>
                  Last Modified
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (file of (files$ | async); track file) {
              <tr>
                <td>
                  @if (file.__typename === 'File') {
                    <i class="fas fa-file"></i>
                  }
                  @if (file.__typename === 'Folder') {
                    <i class="fas fa-folder"></i>
                  }
                </td>
                <td>
                  {{ file.name }}
                </td>
                <td>
                  {{ file?.last_modified | cldate }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

        <label for="src_folder" class="form-label mt-3">From</label>
        <textarea id="src_folder" class="form-control" rows="2" readonly>{{ src_basefolder }}</textarea>
        <label for="dest_prefix" class="form-label mt-3">To</label>
        <input id="dest_prefix" type="text" class="form-control" [(ngModel)]="dst_folder" pattern="s3://\S+/"
          #destbrefix="ngModel"/>
        @if (destbrefix.errors?.pattern) {
          <p class="invalid-feedback">
            The destination must be a single s3:// folder path ending with a slash, with no spaces.
          </p>
        }

        <p class="alert cl-alert-info" role="alert"> This dialog will close automatically once the move is complete, but
        you can close it manually without interrupting the process.</p>
      </div>
      <div class="modal-footer">
        <span class="modal-footer-left cl-spacing-box cl-spacing-none">
          <button type="button" class="btn cl-color-secondary it-cancel"
            (click)="close()">
            <span>Cancel</span>
          </button></span>
          <span class="modal-footer-center">
            <div style="margin-top: -8px;">
              <app-message-field #moveMsg/>
            </div>
          </span>
          <span class="modal-footer-right">
            <app-do-button type="button" buttonClass="btn cl-color-primary" [messageField]="moveMsg" (actionTriggered)="move($event);">
              <span>Move files</span>
            </app-do-button>
          </span>
        </div>

      </div>
    </div>

